export var meetingDetails = [
    {
        value: "1",
        display: "Engagement",
    },
    {
        value: "2",
        display: "Product Sales",
    },
    {
        value: "3",
        display: "Service",
    },
    {
        value: "4",
        display: "Aquisition",
    },
];
export var engagementDetails = [
    {
        value: "Meeting",
        display: "Meeting",
    },
    {
        value: "Call",
        display: "Call",
    },
    {
        value: "Virtual",
        display: "Virtual",
    },
];
export var ownerslist = [
    {
        label: "Meeting",
        value: {
            label: "Meeting",
            value: "28374",
        },
    },
    {
        label: "Meeting",
        value: "28374",
    },
    {
        label: "Meeting",
        value: "28374",
    },
];
export var uploadImgListEnum;
(function (uploadImgListEnum) {
    uploadImgListEnum["CLIENT_PROFILE"] = "Client_Profile";
    uploadImgListEnum["CAR_PHOTO"] = "Car_Photo";
    uploadImgListEnum["HOMO_PHOTO"] = "Home_Photo";
    uploadImgListEnum["OTHERS"] = "Others";
})(uploadImgListEnum || (uploadImgListEnum = {}));
export var uploadImgList = [
    { title: "Profile Photo", value: uploadImgListEnum.CLIENT_PROFILE },
    { title: "Car Photo", value: uploadImgListEnum.CAR_PHOTO },
    { title: "Home Photo", value: uploadImgListEnum.HOMO_PHOTO },
    { title: "Others", value: uploadImgListEnum.OTHERS },
];
export var addEditLeadConstants = {
    INTERNAL_COMMENT_MIN_LENGTH: 15,
};
export var getIsAmountValid = function (actualAmount, comparisonAmount) {
    if (actualAmount !== null &&
        actualAmount !== undefined &&
        comparisonAmount !== null &&
        comparisonAmount !== undefined) {
        var localAmount = void 0;
        var localComparisonAmount = void 0;
        if (typeof actualAmount === "number") {
            localAmount = actualAmount;
        }
        else if (typeof actualAmount === "string") {
            localAmount = parseInt(actualAmount);
        }
        if (typeof comparisonAmount === "number") {
            localComparisonAmount = comparisonAmount;
        }
        else if (typeof comparisonAmount === "string") {
            localComparisonAmount = parseInt(comparisonAmount);
        }
        if (localAmount >= localComparisonAmount) {
            return true;
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
};
export var initialMeetingObj = {
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
    subSourceId: "",
    assignedTo: "",
    leadSource: "",
    productName: "",
    categoryName: "",
    subCategoryName: "",
    isMobileVerified: false,
    isEmailVerified: false,
    leadType: "",
    acCode: "",
    acName: "",
    bucketId: 2,
    bucketName: "Product",
    typeOfContact: "",
    didMeetingHappend: false,
    response: "",
    notes: "",
    remarks: "",
    sourceName: "",
    isJointMeeting: false,
    participants: [],
    externalParticipants: [],
    meetingId: "",
    expenses: [],
    primaryOwner: undefined,
    followupMode: "",
    meetingDate: "",
    meetingTime: "",
    subStatus: "",
    amount: "",
    interaction_sub_statusid: undefined,
    interaction_sub_status: "",
    leadId: "",
    meetingFollowUpDate: "",
    meetingFollowUpTime: "",
    productFeedback: "",
    productId: undefined,
    categoryId: undefined,
    subCategoryId: undefined,
    sourceId: undefined,
    responseId: undefined,
    followupModeId: undefined,
    subStatusId: undefined,
    subSourceName: "",
    meetingClosureDate: "",
    displayName: "",
    displayNameId: undefined,
    meetingClosureTime: "",
    feedbacklist: [],
    primaryproductName: "",
    primaryproductid: undefined,
    interaction_priority: "",
    interaction_priority_id: "",
    // priorityId: undefined,
    // priority: "",
    sendMom: false,
    pan: "",
    parentLeadId: "",
    isClient: true,
    isPanVerified: false,
    isParent: false,
    partnerCode: "",
    sbCode: undefined,
    sbName: "",
    sbPassout: 0,
    isSentMOM: "No",
    isCheckedForEdit: true,
    isfocus: true,
    issuerId: undefined,
    issuerName: "",
};
export var getPANType = function (pan) {
    var _a, _b;
    if (!!pan && ((_a = pan[3]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === "P") {
        return "INDIVIDUAL";
    }
    else if (!!pan && ((_b = pan[3]) === null || _b === void 0 ? void 0 : _b.toUpperCase()) !== "P") {
        return "NON INDIVIDUAL";
    }
};
export var DataOfBirthToolTip = "Additional information needed to retrieve PAN data from the Income Tax website.";
export var momQuestionSet = {
    q1: "Meeting Date",
    q2: "What will be the next follow up date?",
    q3: "What are the products discussed during the meeting?",
    q4: "Does the client need to connect with an Expert Wealth Manager/ Manufacturer Adviser in the next meeting?",
    q5: "Was the client spoken on portfolio solutioning? If Yes Will the client share CAS with us? ",
    q6: "Has the client agreed to share documents for account opening with us?",
};
export var momCheckboxOption = [
    { value: "Yes", display: "Yes" },
    { value: "No", display: "No" },
];
export var momViewErrorText = {
    bucketError: "Atleast 1 product or acquisition lead meeting should be marked as done to send Mom",
};
export var productsId = {
    fixedIncome: 54,
    lifeInsurance: 9,
    aifCategoryId: 293,
    pmsCategoryId: 268,
    structuredProductsCategoryId: 292,
    mutualFundCategoryId: 261,
};
export var clientType = [
    { value: 1, display: "Indian" },
    { value: 2, display: "NRI(Non-Resident Indian)" },
];
export var EAnswerType;
(function (EAnswerType) {
    EAnswerType["YES"] = "YES";
    EAnswerType["NO"] = "NO";
})(EAnswerType || (EAnswerType = {}));
export var KB_IN_ONE_MB = 1024;
